// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"styles_inputContainer__ULOq6","label":"styles_label__RHNz1","dollarSign":"styles_dollarSign__CDAha","input":"styles_input__LxIRD"};